import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { filter, switchMap, take, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const approvedGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.initialized$.pipe(
    filter(initialized => initialized),
    take(1),
    switchMap(() => authService.application$),
    take(1),
    map(application => {
      if (application?.status === 'approved') {
        return true;
      }
      return router.createUrlTree(['/apply']);
    }),
  );
};
